/* ZOALIN_WISHLIST_V1:JS */
(() => {
  const KEY = 'zoalinWishlistV1';
  const ROOT = window.Shopify?.routes?.root || '/';
  const SOFT_LAYERED_PRODUCT_ID_20260820 = '9259616436446';
  const SOFT_LAYERED_REPLACEMENT_IMAGE_20260820 = 'https://cdn.shopify.com/s/files/1/0796/7771/8750/files/zoalin-soft-layered-modest-set-10-camel-lifestyle-closeup-20260820.png?v=1787211484&width=900';
  const SOFT_LAYERED_REPLACEMENT_URL_20260820 = '/products/soft-layered-modest-set?view=image6v2-20260820';
  const VARIANT_SELECTOR =
    '[data-za-variant-select], form[action*="/cart/add"] select[name="id"], form[action*="/cart/add"] input[name="id"], select[name="id"], input[name="id"]';
  let pickerState = null;

  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(value) ? value.filter((item) => item && item.id).map(normalizeWishlistItem) : [];
    } catch (_) { return []; }
  };
  const write = (items) => {
    const normalizedItems = items.map(normalizeWishlistItem);
    localStorage.setItem(KEY, JSON.stringify(normalizedItems));
    document.dispatchEvent(new CustomEvent('zoalin:wishlist-changed', { detail: { items: normalizedItems } }));
    document.dispatchEvent(new CustomEvent('zoalin:wishlist:changed', { detail: { items: normalizedItems } }));
  };
  const syncButtonVariant = (button) => {
    const productScope =
      button.closest('form, .za-product, .za-product-card, product-information, .product-information, [data-product-id]') ||
      document;
    const selectedVariant = productScope.querySelector(VARIANT_SELECTOR);
    if (!selectedVariant?.value) return;

    button.dataset.wishlistVariantId = selectedVariant.value;

    const selectedOption = selectedVariant.options ? selectedVariant.options[selectedVariant.selectedIndex] : null;
    if (selectedOption?.dataset?.wishlistPrice) {
      button.dataset.wishlistPrice = selectedOption.dataset.wishlistPrice;
    } else if (selectedVariant.dataset?.wishlistPrice) {
      button.dataset.wishlistPrice = selectedVariant.dataset.wishlistPrice;
    }
  };
  const getItemFromButton = (button) => {
    syncButtonVariant(button);
    return {
      id: String(button.dataset.wishlistId || ''),
      title: button.dataset.wishlistTitle || '',
      url: button.dataset.wishlistUrl || '#',
      image: button.dataset.wishlistImage || '',
      price: button.dataset.wishlistPrice || '',
      variantId: String(button.dataset.wishlistVariantId || ''),
      savedAt: Date.now(),
    };
  };
  const handleFromUrl = (url) => {
    try {
      return new URL(url || '/', window.location.origin).pathname.split('/').filter(Boolean).pop() || '';
    } catch (_) { return ''; }
  };
  const isSoftLayeredItem = (item = {}) => {
    const handle = item.handle || item.product_handle || handleFromUrl(item.url);
    return String(item.id || item.product_id || '') === SOFT_LAYERED_PRODUCT_ID_20260820 || handle === 'soft-layered-modest-set';
  };
  const normalizeWishlistItem = (item = {}) => {
    if (!isSoftLayeredItem(item)) return item;
    return { ...item, image: SOFT_LAYERED_REPLACEMENT_IMAGE_20260820, url: SOFT_LAYERED_REPLACEMENT_URL_20260820 };
  }; // ZOALIN_SOFT_LAYERED_CARD_WHITE_MEDIA_FIX_20260820
  const wishlistCardImageOverrides = () => {
    const node = document.querySelector('[data-zoalin-wishlist-card-images]');
    if (!node) return {};
    try {
      const value = JSON.parse(node.textContent || '{}');
      return value && typeof value === 'object' ? value : {};
    } catch (_) { return {}; }
  };
  const wishlistCardImage = (item = {}) => {
    if (isSoftLayeredItem(item)) return SOFT_LAYERED_REPLACEMENT_IMAGE_20260820;
    const handle = item.handle || item.product_handle || handleFromUrl(item.url);
    return wishlistCardImageOverrides()[handle] || item.image || '';
  };
  const displayTitle = (item = {}) => {
    const handle = item.handle || item.product_handle || handleFromUrl(item.url);
    const byHandle = {
      'everyday-tunic-and-pants-set': 'Tunic Set',
      'everyday-modest-tunic-set': 'Tunic Set',
      'tailored-modest-two-piece-set': 'Collared Tunic Set',
      'elegant-button-sleeve-tunic-pants-set': 'Button-Sleeve Set',
      'relaxed-modest-lounge-set': 'Relaxed Shirt Set',
      'soft-layered-modest-set': 'Layered Tunic Set',
      'soft-pleated-abaya-dress': 'Gathered Abaya',
      'abstract-print-maxi-dress': 'Abstract Maxi',
      'graceful-button-maxi-dress': 'Ruffle-Hem Maxi',
      'printed-flow-maxi-dress': 'Printed Tunic Set',
    };
    if (byHandle[handle]) return byHandle[handle];

    return String(item.title || item.product_title || '')
      .replace('Everyday Button-Detail Tunic & Pants Set', 'Tunic Set')
      .replace('Tailored Collared Tunic & Wide-Leg Pants Set', 'Collared Tunic Set')
      .replace('Elegant Button-Sleeve Tunic & Pants Set', 'Button-Sleeve Set')
      .replace('Relaxed Button Shirt & Wide-Leg Pants Set', 'Relaxed Shirt Set')
      .replace('Soft Layered Button Tunic & Pants Set', 'Layered Tunic Set')
      .replace('Soft Gathered Abaya Maxi Dress', 'Gathered Abaya')
      .replace('Abstract Print Ruffle-Hem Maxi Dress', 'Abstract Maxi')
      .replace('Graceful Gathered Ruffle-Hem Maxi Dress', 'Ruffle-Hem Maxi')
      .replace('Printed Flow Tunic & Wide-Leg Pants Set', 'Printed Tunic Set');
  };
  const setButtonState = (button, active) => {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    const label = button.querySelector('[data-wishlist-button-label]');
    if (label) label.textContent = active ? 'Saved to wishlist' : 'Add to wishlist';
    const title = button.dataset.wishlistTitle || 'item';
    button.setAttribute('aria-label', active ? 'Remove ' + title + ' from wishlist' : 'Add ' + title + ' to wishlist');
  };
  const HEADER_WISHLIST_SELECTOR =
    '#header-component [data-zoalin-wishlist-header], header-component [data-zoalin-wishlist-header], header [data-zoalin-wishlist-header], #header-component a[href*="view=wishlist"], header-component a[href*="view=wishlist"], header a[href*="view=wishlist"]';
  const HEADER_COUNT_SELECTOR = '[data-zoalin-wishlist-count], .zoalin-wishlist-header__count, .za-actions__count';
  const ensureHeaderCounts = () => {
    document.querySelectorAll(HEADER_WISHLIST_SELECTOR).forEach((link) => {
      const counts = Array.from(link.querySelectorAll(HEADER_COUNT_SELECTOR));
      const primary =
        counts.find((node) => node.matches('[data-zoalin-wishlist-count].za-actions__count')) ||
        counts.find((node) => node.matches('[data-zoalin-wishlist-count]')) ||
        counts[0] ||
        document.createElement('span');
      if (!primary.parentElement) {
        primary.textContent = '0';
        primary.hidden = true;
        link.appendChild(primary);
      }
      primary.classList.add('za-actions__count');
      primary.classList.remove('zoalin-wishlist-header__count');
      primary.setAttribute('data-zoalin-wishlist-count', '');
      counts.forEach((node) => {
        if (node !== primary) node.remove();
      });
    });
  };
  let headerCountCleanupQueued = false;
  const scheduleHeaderCountCleanup = () => {
    if (headerCountCleanupQueued) return;
    headerCountCleanupQueued = true;
    window.requestAnimationFrame(() => {
      headerCountCleanupQueued = false;
      ensureHeaderCounts();
    });
  };
  const watchHeaderCounts = () => {
    new MutationObserver(scheduleHeaderCountCleanup).observe(document.documentElement, { childList: true, subtree: true });
  };
  const visible = (node) => {
    const rect = node?.getBoundingClientRect?.();
    if (!rect) return false;
    const style = window.getComputedStyle(node);
    return rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden';
  };
  const activeToggleCount = () => {
    const ids = new Set();
    document
      .querySelectorAll(
        '[data-zoalin-wishlist-toggle].is-active, [data-zoalin-wishlist-toggle][aria-pressed="true"], [data-wishlist-toggle].is-active, [data-wishlist-toggle][aria-pressed="true"]',
      )
      .forEach((button, index) => {
        if (!visible(button) || button.closest('#header-component, header-component, header .header__column--right')) return;
        const link = button.closest('a[href*="/products/"]') || button.parentElement?.querySelector?.('a[href*="/products/"]');
        const id =
          button.dataset.wishlistId ||
          button.dataset.productId ||
          button.dataset.wishlistProductId ||
          button.getAttribute('data-product-id') ||
          link?.getAttribute('href') ||
          String(index);
        if (id) ids.add(String(id));
      });
    return ids.size;
  };
  const refresh = () => {
    const items = read();
    const displayCount = Math.max(items.length, activeToggleCount());
    const ids = new Set(items.map((item) => String(item.id)));
    ensureHeaderCounts();
    document.querySelectorAll('[data-zoalin-wishlist-toggle]').forEach((button) => {
      setButtonState(button, ids.has(String(button.dataset.wishlistId)));
    });
    document.querySelectorAll('[data-zoalin-wishlist-count]').forEach((node) => {
      node.textContent = String(displayCount);
      node.hidden = displayCount === 0;
    });
    document.querySelectorAll('[data-zoalin-wishlist-header]').forEach((node) => node.classList.toggle('is-active', displayCount > 0));
    renderPage(items);
  };
  const toggle = (button) => {
    const item = getItemFromButton(button);
    if (!item.id) return;
    const items = read();
    const index = items.findIndex((entry) => String(entry.id) === item.id);
    if (index >= 0) items.splice(index, 1);
    else items.unshift(item);
    write(items);
  };
  const create = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  };
  const addVariantToCart = async (variantId, button) => {
    if (!variantId) throw new Error('A product option must be selected');

    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';
    const response = await fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
    });
    const payload = await response.json().catch(() => null);
    if (!response.ok) throw new Error(payload?.description || 'Unable to add item');
    button.textContent = 'Added to bag';
    document.dispatchEvent(new CustomEvent('zoalin:quick-add:added', { detail: { variantId, payload } }));

    window.setTimeout(() => {
      const hadPicker = Boolean(pickerState);
      if (hadPicker) closePicker();
      document.dispatchEvent(new CustomEvent('zoalin:cart:refresh-open'));
      if (!hadPicker) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }, 260);
  };
  const variantValues = (variant, count) => {
    if (Array.isArray(variant.options) && variant.options.length) return variant.options.map(String);
    return Array.from({ length: count }, (_, index) => String(variant['option' + (index + 1)] || ''));
  };
  const variantImageUrl = (variant) => {
    const image = variant?.featured_image || variant?.featured_media?.preview_image || variant?.image;
    if (typeof image === 'string') return image;
    return image?.src || image?.url || '';
  };
  const ensurePicker = () => {
    let picker = document.querySelector('[data-wishlist-picker]');
    if (picker) return picker;
    picker = create('div', 'zoalin-wishlist-picker');
    picker.hidden = true;
    picker.dataset.wishlistPicker = '';
    picker.innerHTML = '<div class="zoalin-wishlist-picker__dialog" role="dialog" aria-modal="true" aria-labelledby="zoalin-wishlist-picker-title"><button type="button" class="zoalin-wishlist-picker__close" aria-label="Close option selector" data-wishlist-picker-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button><div class="zoalin-wishlist-picker__head"><img class="zoalin-wishlist-picker__image" src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==" data-wishlist-picker-image alt=""><div class="zoalin-wishlist-picker__copy"><p class="zoalin-wishlist-picker__eyebrow">Choose your options</p><h2 class="zoalin-wishlist-picker__title" id="zoalin-wishlist-picker-title" data-wishlist-picker-title></h2></div></div><div class="zoalin-wishlist-picker__options" data-wishlist-picker-options></div><p class="zoalin-wishlist-picker__status" data-wishlist-picker-status>Please select all options.</p><button type="button" class="zoalin-wishlist-picker__confirm" data-wishlist-picker-confirm disabled>Select options</button></div>';
    document.body.append(picker);
    return picker;
  };
  const closePicker = () => {
    const picker = document.querySelector('[data-wishlist-picker]');
    if (picker) picker.hidden = true;
    pickerState = null;
    document.body.classList.remove('zoalin-wishlist-picker-open');
  };
  const renderPickerState = () => {
    if (!pickerState) return;
    const picker = ensurePicker();
    const variants = pickerState.product.variants || [];
    picker.querySelectorAll('[data-wishlist-option-index]').forEach((button) => {
      const index = Number(button.dataset.wishlistOptionIndex);
      const value = button.dataset.wishlistOptionValue;
      const possible = variants.some((variant) => {
        if (variant.available === false) return false;
        const values = variantValues(variant, pickerState.optionNames.length);
        if (values[index] !== value) return false;
        return pickerState.selections.every((selected, otherIndex) => otherIndex === index || !selected || values[otherIndex] === selected);
      });
      button.disabled = !possible;
      button.classList.toggle('is-selected', pickerState.selections[index] === value);
      button.setAttribute('aria-pressed', pickerState.selections[index] === value ? 'true' : 'false');
    });
    const complete = pickerState.selections.every(Boolean);
    const selectedVariant = complete ? variants.find((variant) => {
      const values = variantValues(variant, pickerState.optionNames.length);
      return variant.available !== false && values.every((value, index) => value === pickerState.selections[index]);
    }) : null;
    pickerState.selectedVariant = selectedVariant || null;
    const colorIndex = pickerState.optionNames.findIndex((name) => /colou?r/i.test(name));
    const hasSelectedColor = colorIndex >= 0 && Boolean(pickerState.selections[colorIndex]);
    const imageVariant = hasSelectedColor ? variants.find((variant) => {
      if (variant.available === false || !variantImageUrl(variant)) return false;
      const values = variantValues(variant, pickerState.optionNames.length);
      return pickerState.selections.every((selected, index) => !selected || values[index] === selected);
    }) : selectedVariant;
    const pickerImage = picker.querySelector('[data-wishlist-picker-image]');
    const selectedImageUrl = variantImageUrl(selectedVariant) || variantImageUrl(imageVariant);
    if (selectedImageUrl) {
      pickerImage.src = selectedImageUrl;
      pickerImage.alt = [pickerState.product.title, colorIndex >= 0 ? pickerState.selections[colorIndex] : ''].filter(Boolean).join(' - ');
    } else if (!hasSelectedColor && pickerState.defaultImage) {
      pickerImage.src = pickerState.defaultImage;
      pickerImage.alt = pickerState.product.title || '';
    }
    const status = picker.querySelector('[data-wishlist-picker-status]');
    const confirm = picker.querySelector('[data-wishlist-picker-confirm]');
    if (!complete) {
      status.textContent = 'Please select ' + pickerState.optionNames.filter((_, index) => !pickerState.selections[index]).join(' and ') + '.';
      confirm.textContent = 'Select options';
      confirm.disabled = true;
    } else if (!selectedVariant) {
      status.textContent = 'This combination is currently unavailable.';
      confirm.textContent = 'Unavailable';
      confirm.disabled = true;
    } else {
      status.textContent = 'Your selected combination is available.';
      confirm.textContent = 'Add selected item to bag';
      confirm.disabled = false;
    }
  };
  const openPicker = async (button) => {
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Loading options...';
    try {
      const productUrl = new URL(button.dataset.wishlistUrl || ROOT, window.location.origin);
      productUrl.search = '';
      productUrl.hash = '';
      productUrl.pathname = productUrl.pathname.replace(/\/$/, '') + '.js';
      const response = await fetch(productUrl.toString(), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Unable to load options');
      const product = await response.json();
      const availableVariants = (product.variants || []).filter((variant) => variant.available !== false);
      if ((product.variants || []).length === 1 && availableVariants.length === 1) {
        await addVariantToCart(availableVariants[0].id, button);
        return;
      }
      const optionNames = (product.options || []).map((option, index) => typeof option === 'string' ? option : (option.name || 'Option ' + (index + 1)));
      if (!optionNames.length) throw new Error('No selectable options found');
      const picker = ensurePicker();
      picker.querySelector('[data-wishlist-picker-title]').textContent = displayTitle({
        handle: product.handle,
        title: product.title || button.dataset.wishlistTitle || 'Product',
        url: button.dataset.wishlistUrl,
      });
      const pickerImage = picker.querySelector('[data-wishlist-picker-image]');
      pickerImage.src = button.dataset.wishlistImage || product.featured_image || '';
      pickerImage.alt = product.title || button.dataset.wishlistTitle || '';
      const optionsRoot = picker.querySelector('[data-wishlist-picker-options]');
      optionsRoot.replaceChildren();
      optionNames.forEach((name, index) => {
        const group = create('fieldset', 'zoalin-wishlist-picker__group');
        const legend = create('legend', 'zoalin-wishlist-picker__legend', name);
        const valuesRoot = create('div', 'zoalin-wishlist-picker__values');
        const values = [...new Set((product.variants || []).map((variant) => variantValues(variant, optionNames.length)[index]).filter(Boolean))];
        values.forEach((value) => {
          const optionButton = create('button', 'zoalin-wishlist-picker__option', value);
          optionButton.type = 'button';
          optionButton.dataset.wishlistOptionIndex = String(index);
          optionButton.dataset.wishlistOptionValue = value;
          optionButton.setAttribute('aria-pressed', 'false');
          valuesRoot.append(optionButton);
        });
        group.append(legend, valuesRoot);
        optionsRoot.append(group);
      });
      pickerState = { product, optionNames, selections: Array(optionNames.length).fill(null), selectedVariant: null, sourceButton: button, defaultImage: pickerImage.src };
      picker.hidden = false;
      document.body.classList.add('zoalin-wishlist-picker-open');
      renderPickerState();
      picker.querySelector('[data-wishlist-picker-close]').focus();
    } catch (_) {
      button.disabled = false;
      button.textContent = 'Choose on product page';
      window.setTimeout(() => { window.location.href = button.dataset.wishlistUrl || ROOT; }, 350);
    } finally {
      if (!pickerState && button.textContent === 'Loading options...') {
        button.disabled = false;
        button.textContent = originalText;
      } else if (pickerState) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  };
  const renderPage = (items = read()) => {
    const page = document.querySelector('[data-zoalin-wishlist-page]');
    if (!page) return;
    const grid = page.querySelector('[data-zoalin-wishlist-grid]');
    const empty = page.querySelector('[data-zoalin-wishlist-empty]');
    if (!grid || !empty) return;
    grid.replaceChildren();
    const hasItems = items.length !== 0;
    empty.hidden = hasItems;
    empty.style.display = hasItems ? 'none' : '';
    grid.hidden = !hasItems;
    grid.style.display = hasItems ? '' : 'none';
    items.forEach((item) => {
      const cardImage = wishlistCardImage(item);
      const card = create('article', 'zoalin-wishlist-item');
      const imageLink = create('a', 'zoalin-wishlist-item__image-wrap');
      imageLink.href = item.url || '#';
      const image = create('img', 'zoalin-wishlist-item__image');
      image.src = cardImage;
      image.alt = item.title || '';
      image.loading = 'lazy';
      imageLink.append(image);
      const remove = create('button', 'zoalin-wishlist-item__remove');
      remove.type = 'button';
      remove.setAttribute('aria-label', 'Remove ' + (item.title || 'item') + ' from wishlist');
      remove.dataset.wishlistRemove = String(item.id);
      remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.45" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      const body = create('div', 'zoalin-wishlist-item__body');
      const title = create('a', 'zoalin-wishlist-item__title', displayTitle(item) || 'Product');
      title.href = item.url || '#';
      const price = create('p', 'zoalin-wishlist-item__price', item.price || '');
      const add = create('button', 'zoalin-wishlist-item__add', 'Add to bag');
      add.type = 'button';
      add.dataset.wishlistAdd = item.variantId || '';
      add.dataset.wishlistUrl = item.url || '#';
      add.dataset.wishlistTitle = item.title || '';
      add.dataset.wishlistImage = cardImage;
      body.append(title, price, add);
      card.append(imageLink, remove, body);
      grid.append(card);
    });
  };

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element)) return;
    const variantField = event.target.matches(VARIANT_SELECTOR)
      ? event.target
      : event.target.closest(VARIANT_SELECTOR);
    if (!variantField) return;

    const productScope =
      variantField.closest('form, .za-product, .za-product-card, product-information, .product-information, [data-product-id]') ||
      document;

    productScope.querySelectorAll('[data-zoalin-wishlist-toggle]').forEach(syncButtonVariant);
  });

  document.addEventListener('click', async (event) => {
    const toggleButton = event.target.closest('[data-zoalin-wishlist-toggle]');
    if (toggleButton) {
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton);
      return;
    }
    const removeButton = event.target.closest('[data-wishlist-remove]');
    if (removeButton) {
      const items = read().filter((item) => String(item.id) !== String(removeButton.dataset.wishlistRemove));
      write(items);
      return;
    }
    const addButton = event.target.closest('[data-wishlist-add]');
    if (addButton) {
      await openPicker(addButton);
      return;
    }
    const optionButton = event.target.closest('[data-wishlist-option-index]');
    if (optionButton && pickerState) {
      const index = Number(optionButton.dataset.wishlistOptionIndex);
      pickerState.selections[index] = optionButton.dataset.wishlistOptionValue;
      renderPickerState();
      return;
    }
    const confirmButton = event.target.closest('[data-wishlist-picker-confirm]');
    if (confirmButton && pickerState?.selectedVariant) {
      try {
        await addVariantToCart(pickerState.selectedVariant.id, confirmButton);
      } catch (_) {
        confirmButton.disabled = false;
        confirmButton.textContent = 'Try again';
      }
      return;
    }
    if (event.target.closest('[data-wishlist-picker-close]') || (event.target.matches('[data-wishlist-picker]'))) {
      closePicker();
    }
  });
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && pickerState) closePicker(); });
  document.addEventListener('zoalin:wishlist-changed', refresh);
  window.addEventListener('storage', refresh);
  document.addEventListener('shopify:section:load', refresh);
  watchHeaderCounts();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
  [80, 240, 720, 1400].forEach((delay) => window.setTimeout(refresh, delay));
})();

(() => {
  const MARKER = 'ZOALIN_PC_PDP_MEDIA_BG_RUNTIME_20260728';
  const STYLE_ID = 'zoalin-pc-pdp-media-bg-runtime-20260728';
  const BG = '#f8f2ee';
  const QUERY = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  const SELECTORS = [
    '#MainContent .product-information__media',
    '#MainContent .product-information__media media-gallery.media-gallery--grid',
    '#MainContent .product-information__media media-gallery.media-gallery--grid slideshow-component',
    '#MainContent .product-information__media media-gallery.media-gallery--grid slideshow-container',
    '#MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slides',
    '#MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slide',
    '#MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slide.product-media-container',
    '#MainContent .product-information__media media-gallery.media-gallery--grid .product-media-container',
    '#MainContent .product-information__media media-gallery.media-gallery--grid .product-media-constraint-wrapper',
    '#MainContent .product-information__media media-gallery.media-gallery--grid .product-media',
    '#MainContent .product-information__media media-gallery.media-gallery--grid :is(img, video, iframe, .deferred-media__poster-image, .product-media__image)',
  ];

  function shouldRun() {
    return document.body?.classList?.contains('template-product') && window.matchMedia?.(QUERY)?.matches;
  }

  function injectStyle() {
    let style = document.getElementById(STYLE_ID);
    if (!style) {
      style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = `/* ${MARKER} */@media screen and ${QUERY}{html body[class].template-product #MainContent .product-information__media{--zoalin-pdp-media-bg:${BG}!important}html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid slideshow-component,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid slideshow-container,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slides,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slide,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid slideshow-slide.product-media-container,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid .product-media-container,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid .product-media-constraint-wrapper,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid .product-media,html body[class].template-product #MainContent .product-information__media media-gallery.media-gallery--grid :is(img,video,iframe,.deferred-media__poster-image,.product-media__image){background:${BG}!important;background-color:${BG}!important}}`;
    }
    document.head?.appendChild(style);
  }

  function paint() {
    if (!shouldRun()) return;
    injectStyle();
    document.documentElement.setAttribute('data-zoalin-pdp-media-bg-runtime', MARKER);
    document.querySelectorAll(SELECTORS.join(',')).forEach((element) => {
      element.style.setProperty('--zoalin-pdp-media-bg', BG, 'important');
      element.style.setProperty('background', BG, 'important');
      element.style.setProperty('background-color', BG, 'important');
    });
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      paint();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', paint, { once: true });
  else paint();
  window.addEventListener('load', paint);
  window.addEventListener('pageshow', paint);
  window.addEventListener('resize', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  [0, 60, 180, 420, 900, 1600, 3000, 6000].forEach((delay) => setTimeout(paint, delay));
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ZOALIN_PC_HEADER_BADGE_ANCHOR_FIX_20260726_2248 */
/* ZOALIN_PC_HEADER_RIGHT_RAIL_RUNTIME_20260729 */
(() => {
  const QUERY = '(min-width: 990px)';
  const set = (node, prop, value) => node?.style?.setProperty(prop, value, 'important');
  const RAIL_BOX = 44;
  const RAIL_GAP = 10;
  const RAIL_ACTIONS_WIDTH = RAIL_BOX * 3 + RAIL_GAP * 2;
  const RAIL_WIDTH = RAIL_BOX * 4 + RAIL_GAP * 3;
  const PAGE_MAX_WIDTH = 1440;
  const RIGHT_EDGE_OFFSET = -8;
  const MIN_RIGHT_EDGE = 48;
  const px = (value) => `${value}px`;
  const railRight = () => px(Math.max(MIN_RIGHT_EDGE, Math.round((window.innerWidth - PAGE_MAX_WIDTH) / 2 + RIGHT_EDGE_OFFSET)));
  const railTop = (header) => {
    const host = document.querySelector('#header-component, header-component') || header;
    const rect = host && host.getBoundingClientRect ? host.getBoundingClientRect() : null;
    const height = rect && rect.height ? rect.height : 54;
    return px(Math.max(0, Math.round((rect ? rect.top : 0) + (height - RAIL_BOX) / 2)));
  };
  const hide = (node) => {
    set(node, 'display', 'none');
    set(node, 'visibility', 'hidden');
    set(node, 'pointer-events', 'none');
  };

  const showBadge = (node, display) => {
    set(node, 'display', display);
    set(node, 'visibility', 'visible');
    set(node, 'pointer-events', 'none');
  };

  const anchorNode = (node) => {
    set(node, 'position', 'relative');
    set(node, 'inset', 'auto');
    set(node, 'top', 'auto');
    set(node, 'right', 'auto');
    set(node, 'bottom', 'auto');
    set(node, 'left', 'auto');
    set(node, 'overflow', 'visible');
    set(node, 'isolation', 'isolate');
    set(node, 'transform', 'none');
    set(node, 'box-sizing', 'border-box');
  };

  const normalizeSpacing = (node) => {
    set(node, 'margin-left', '0');
    set(node, 'margin-right', '0');
    set(node, 'margin-top', '0');
    set(node, 'margin-bottom', '0');
  };

  const setIconBox = (node, size = '44px') => {
    if (!node) return;
    if (typeof size !== 'string') size = '44px';
    anchorNode(node);
    normalizeSpacing(node);
    set(node, 'display', 'flex');
    set(node, 'align-items', 'center');
    set(node, 'justify-content', 'center');
    set(node, 'flex', `0 0 ${size}`);
    set(node, 'width', size);
    set(node, 'min-width', size);
    set(node, 'max-width', size);
    set(node, 'height', size);
    set(node, 'min-height', size);
    set(node, 'max-height', size);
    set(node, 'padding', '0');
    set(node, 'visibility', 'visible');
    set(node, 'opacity', '1');
    set(node, 'pointer-events', 'auto');
  };

  const enforceHeaderGap = (column, search, actions, account) => {
    if (!column || !search || !actions || !account) return;
    const searchBox = search.getBoundingClientRect();
    const accountBox = account.getBoundingClientRect();
    const needed = Math.ceil(searchBox.right + 8 - accountBox.left);
    if (needed <= 0) return;
    const currentMargin = parseFloat(getComputedStyle(actions).marginLeft) || 0;
    const nextMargin = Math.max(RAIL_GAP, currentMargin + needed);
    const nextWidth = Math.max(RAIL_WIDTH, RAIL_WIDTH - RAIL_GAP + nextMargin);
    set(actions, 'margin-left', `${nextMargin}px`);
    set(column, 'width', `${nextWidth}px`);
    set(column, 'min-width', `${nextWidth}px`);
    set(column, 'max-width', `${nextWidth}px`);
  };

  const placeHeaderRail = (header) => {
    const column = header.querySelector('.header__column--right');
    if (!column) return;

    set(column, 'display', 'flex');
    set(column, 'position', 'fixed');
    set(column, 'right', railRight());
    set(column, 'left', 'auto');
    set(column, 'top', railTop(header));
    set(column, 'bottom', 'auto');
    set(column, 'align-items', 'center');
    set(column, 'justify-content', 'flex-end');
    set(column, 'gap', '0');
    set(column, 'column-gap', '0');
    set(column, 'row-gap', '0');
    set(column, 'width', px(RAIL_WIDTH));
    set(column, 'min-width', px(RAIL_WIDTH));
    set(column, 'max-width', px(RAIL_WIDTH));
    set(column, 'height', px(RAIL_BOX));
    set(column, 'min-height', px(RAIL_BOX));
    set(column, 'max-height', px(RAIL_BOX));
    set(column, 'margin', '0');
    set(column, 'margin-left', '0');
    set(column, 'padding', '0');
    set(column, 'overflow', 'visible');
    set(column, 'transform', 'none');
    set(column, 'z-index', '60');
    set(column, 'pointer-events', 'auto');
    set(column, 'box-sizing', 'border-box');

    const search = column.querySelector(':scope > search-button.search-action--hidden-on-drawer, :scope > .search-action--hidden-on-drawer');
    column.querySelectorAll(':scope > search-button.search-action--hidden-on-drawer, :scope > .search-action--hidden-on-drawer').forEach((searchNode) => {
      setIconBox(searchNode);
      set(searchNode, 'position', 'static');
      set(searchNode, 'margin-right', '0');
      searchNode.querySelectorAll(':scope > .header-actions__action, :scope > button').forEach((node) => setIconBox(node));
    });

    column.querySelectorAll(':scope > header-actions, :scope > .header-actions').forEach((actions) => {
      set(actions, 'position', 'static');
      set(actions, 'inset', 'auto');
      set(actions, 'display', 'grid');
      set(actions, 'grid-template-columns', 'repeat(3, 44px)');
      set(actions, 'grid-auto-columns', '44px');
      set(actions, 'align-items', 'center');
      set(actions, 'justify-items', 'center');
      set(actions, 'justify-content', 'end');
      set(actions, 'gap', '0');
      set(actions, 'column-gap', px(RAIL_GAP));
      set(actions, 'row-gap', '0');
      set(actions, 'flex', `0 0 ${px(RAIL_ACTIONS_WIDTH)}`);
      set(actions, 'width', px(RAIL_ACTIONS_WIDTH));
      set(actions, 'min-width', px(RAIL_ACTIONS_WIDTH));
      set(actions, 'max-width', px(RAIL_ACTIONS_WIDTH));
      set(actions, 'height', px(RAIL_BOX));
      set(actions, 'min-height', px(RAIL_BOX));
      set(actions, 'max-height', px(RAIL_BOX));
      set(actions, 'margin', '0');
      set(actions, 'margin-left', px(RAIL_GAP));
      set(actions, 'padding', '0');
      set(actions, 'overflow', 'visible');
      set(actions, 'transform', 'none');
      set(actions, 'box-sizing', 'border-box');

      const account = actions.querySelector(':scope > .zoalin-account-hosted-link-20260707');
      if (account) {
        actions.querySelectorAll(':scope > .account-button:not(.zoalin-account-hosted-link-20260707), :scope > shopify-account, :scope > shopify-account-button').forEach(hide);
        setIconBox(account);
        set(account, 'grid-column', '1');
        account.querySelectorAll('.account-button__text').forEach(hide);
        account.querySelectorAll('.zoalin-account-icon-wrap').forEach((wrap) => {
          setIconBox(wrap, '18px');
          set(wrap, 'flex', '0 0 18px');
        });
        account.querySelectorAll('svg.account-button__icon').forEach((svg) => {
          setIconBox(svg, '18px');
          set(svg, 'display', 'block');
          set(svg, 'flex', '0 0 18px');
          set(svg, 'overflow', 'visible');
        });
      }

      const wishlist = actions.querySelector(':scope > a.zoalin-wishlist-header[data-zoalin-wishlist-header]');
      if (wishlist) {
        setIconBox(wishlist);
        set(wishlist, 'grid-column', '2');
      }

      const cart = actions.querySelector(':scope > [data-testid="cart-drawer-trigger"], :scope > .action__cart, :scope > .header-actions__action:has(cart-icon), :scope > .header-actions__action:has(.header-actions__cart-icon)');
      if (cart) {
        setIconBox(cart);
        set(cart, 'grid-column', '3');
      }
      enforceHeaderGap(column, search, actions, account);
    });
  };

  const normalizeCartIcon = (icon) => {
    setIconBox(icon);
    set(icon, '--cart-bubble-size', '17px');
    set(icon, '--cart-bubble-top', '-6px');
    set(icon, '--cart-bubble-right', '-7px');
    set(icon, 'position', 'relative');
    set(icon, 'overflow', 'visible');
    icon.querySelectorAll(':scope > .svg-wrapper').forEach((wrap) => {
      setIconBox(wrap, '20px');
      set(wrap, 'flex', '0 0 20px');
      set(wrap, 'z-index', '1');
      set(wrap, 'position', 'relative');
    });
    icon.querySelectorAll(':scope > .svg-wrapper > svg, :scope > svg').forEach((svg) => {
      setIconBox(svg, '20px');
      set(svg, 'display', 'block');
      set(svg, 'flex', '0 0 20px');
      set(svg, 'z-index', '1');
      set(svg, 'overflow', 'visible');
      set(svg, 'color', 'currentColor');
      set(svg, 'mask', 'none');
      set(svg, 'mask-image', 'none');
      set(svg, '-webkit-mask', 'none');
      set(svg, '-webkit-mask-image', 'none');
    });
  };

  const placeBadge = (node, top, right, display) => {
    if (!node) return;
    set(node, 'position', 'absolute');
    set(node, 'top', top);
    set(node, 'right', right);
    set(node, 'bottom', 'auto');
    set(node, 'left', 'auto');
    set(node, 'z-index', '4');
    set(node, 'width', '17px');
    set(node, 'min-width', '17px');
    set(node, 'max-width', '17px');
    set(node, 'height', '17px');
    set(node, 'min-height', '17px');
    set(node, 'max-height', '17px');
    set(node, 'padding', '0');
    set(node, 'border-radius', '999px');
    set(node, 'background', '#000');
    set(node, 'color', '#fff');
    set(node, 'font-size', '9px');
    set(node, 'font-weight', '700');
    set(node, 'line-height', '1');
    set(node, 'transform', 'none');
    showBadge(node, display);
  };

  const placeCartBubble = (bubble) => {
    if (!bubble || bubble.classList.contains('visually-hidden')) {
      hide(bubble);
      return;
    }
    placeBadge(bubble, '-6px', '-7px', 'flex');
    set(bubble, 'width', '17px');
    set(bubble, 'min-width', '17px');
    set(bubble, 'max-width', '17px');
    set(bubble, 'height', '17px');
    set(bubble, 'min-height', '17px');
    set(bubble, 'max-height', '17px');
    set(bubble, 'font-size', '9px');
    set(bubble, 'z-index', '4');
    bubble.querySelectorAll('.cart-bubble__background').forEach((node) => {
      set(node, 'position', 'absolute');
      set(node, 'inset', '0');
      set(node, 'border-radius', '999px');
      set(node, 'background', '#000');
    });
    bubble.querySelectorAll('.cart-bubble__text, .cart-bubble__text-count').forEach((node) => {
      set(node, 'position', 'relative');
      set(node, 'z-index', '1');
      set(node, 'display', 'flex');
      set(node, 'align-items', 'center');
      set(node, 'justify-content', 'center');
      set(node, 'width', '100%');
      set(node, 'height', '100%');
      set(node, 'color', '#fff');
      set(node, 'font-size', '9px');
      set(node, 'font-weight', '700');
      set(node, 'line-height', '1');
      set(node, 'transform', 'none');
    });
  };

  const placeWishlistBadge = (count) => {
    const text = (count?.textContent || '').trim();
    if (!count || text === '' || text === '0') {
      hide(count);
      return;
    }

    /* ZOALIN_PC_WISHLIST_BADGE_CART_ALIGN_20260730_V8
       Anchor wishlist and cart badges to the same 22px icon box. */
    const link = count.closest('a.zoalin-wishlist-header[data-zoalin-wishlist-header], [data-zoalin-wishlist-header]');
    let host =
      link?.querySelector(':scope > .zoalin-pc-heroicons-header-wrap, :scope > .zoalin-pc-menu-header-icon-wrap-final, :scope > .svg-wrapper') ||
      link?.querySelector('.zoalin-pc-heroicons-header-wrap, .zoalin-pc-menu-header-icon-wrap-final, .svg-wrapper') ||
      count.closest('.zoalin-pc-heroicons-header-wrap, .zoalin-pc-menu-header-icon-wrap-final, .svg-wrapper');
    if (!host && link) {
      host = link.querySelector(':scope > .zoalin-pc-wishlist-badge-anchor-20260730');
      if (!host) {
        host = document.createElement('span');
        host.className = 'zoalin-pc-wishlist-badge-anchor-20260730';
        link.insertBefore(host, link.firstChild);
      }
    }
    host = host || count.parentElement;
    if (host && count.parentElement !== host) host.appendChild(count);
    if (host) {
      set(host, 'position', 'relative');
      set(host, 'overflow', 'visible');
      set(host, 'width', '22px');
      set(host, 'min-width', '22px');
      set(host, 'max-width', '22px');
      set(host, 'height', '22px');
      set(host, 'min-height', '22px');
      set(host, 'max-height', '22px');
    }
    placeBadge(count, '-6px', '-7px', 'flex');
    set(count, 'width', '17px');
    set(count, 'min-width', '17px');
    set(count, 'max-width', '17px');
    set(count, 'height', '17px');
    set(count, 'min-height', '17px');
    set(count, 'max-height', '17px');
    set(count, 'padding', '0');
    set(count, 'font-size', '9px');
    set(count, 'font-weight', '700');
    set(count, 'line-height', '1');
    set(count, 'align-items', 'center');
    set(count, 'justify-content', 'center');
    set(count, 'place-items', 'center');
    set(count, 'z-index', '4');
    set(count, 'transition', 'none');
    set(count, 'animation', 'none');
    set(count, 'will-change', 'auto');
  };

  const run = () => {
    if (!window.matchMedia(QUERY).matches) return;
    document.querySelectorAll('#header-component, header-component').forEach((header) => {
      placeHeaderRail(header);
      header.querySelectorAll('header-actions > .header-actions__action, .header-actions > .header-actions__action').forEach((node) => setIconBox(node));

      header.querySelectorAll('a.zoalin-wishlist-header[data-zoalin-wishlist-header]').forEach((link) => {
        anchorNode(link);
        const count = link.querySelector('.zoalin-wishlist-header__count');
        placeWishlistBadge(count);
      });

      header.querySelectorAll('cart-icon, .header-actions__cart-icon').forEach((icon) => {
        normalizeCartIcon(icon);
        icon.querySelectorAll(':scope > .cart-bubble').forEach(placeCartBubble);
      });

      header.querySelectorAll('.cart-bubble').forEach((bubble) => {
        if (!bubble.closest('cart-icon, .header-actions__cart-icon')) hide(bubble);
      });
    });

    document.querySelectorAll('body > .cart-bubble, body > .zoalin-wishlist-header__count, .page-wrapper > .cart-bubble, .page-wrapper > .zoalin-wishlist-header__count').forEach(hide);
  };

  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      run();
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();
  window.addEventListener('load', run);
  window.addEventListener('resize', schedule);
  window.addEventListener('scroll', schedule, { passive: true });
  window.visualViewport?.addEventListener('resize', schedule);
  document.addEventListener('zoalin:wishlist-changed', run);
  document.addEventListener('cart:update', run);
  document.addEventListener('cart:refresh', run);
  [80, 260, 700, 1400, 2800].forEach((delay) => setTimeout(run, delay));
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'hidden'] });
})();

/* ZOALIN_PC_WISHLIST_BADGE_FINAL_ALIGN_20260730
   Last-pass guard: keep the wishlist count badge level with the cart badge. */
(function () {
  const QUERY = '(min-width: 990px) and (hover: hover) and (pointer: fine)';
  const mq = window.matchMedia && window.matchMedia(QUERY);
  const important = (node, prop, value) => {
    if (node && node.style) node.style.setProperty(prop, value, 'important');
  };
  const isVisibleCount = (node) => node && (node.textContent || '').trim() !== '' && (node.textContent || '').trim() !== '0';

  function alignWishlistBadges() {
    if (!(mq && mq.matches)) return;
    document.querySelectorAll('#header-component a.zoalin-wishlist-header, header-component a.zoalin-wishlist-header, #header-component [data-zoalin-wishlist-header], header-component [data-zoalin-wishlist-header]').forEach((link) => {
      const badge = link.querySelector('.zoalin-wishlist-header__count, [data-zoalin-wishlist-count]');
      if (!badge) return;
      important(link, 'position', 'relative');
      important(link, 'overflow', 'visible');
      important(link, 'isolation', 'isolate');
      if (!isVisibleCount(badge)) {
        important(badge, 'display', 'none');
        return;
      }
      let host =
        link.querySelector(':scope > .zoalin-pc-heroicons-header-wrap, :scope > .zoalin-pc-menu-header-icon-wrap-final, :scope > .svg-wrapper') ||
        link.querySelector('.zoalin-pc-heroicons-header-wrap, .zoalin-pc-menu-header-icon-wrap-final, .svg-wrapper');
      if (!host) {
        host = link.querySelector(':scope > .zoalin-pc-wishlist-badge-anchor-20260730');
        if (!host) {
          host = document.createElement('span');
          host.className = 'zoalin-pc-wishlist-badge-anchor-20260730';
          link.insertBefore(host, link.firstChild);
        }
      }
      if (badge.parentElement !== host) host.appendChild(badge);
      important(host, 'position', 'relative');
      important(host, 'overflow', 'visible');
      important(host, 'width', '22px');
      important(host, 'min-width', '22px');
      important(host, 'max-width', '22px');
      important(host, 'height', '22px');
      important(host, 'min-height', '22px');
      important(host, 'max-height', '22px');
      important(badge, 'position', 'absolute');
      important(badge, 'top', '-6px');
      important(badge, 'right', '-7px');
      important(badge, 'left', 'auto');
      important(badge, 'bottom', 'auto');
      important(badge, 'display', 'inline-flex');
      important(badge, 'align-items', 'center');
      important(badge, 'justify-content', 'center');
      important(badge, 'width', '17px');
      important(badge, 'min-width', '17px');
      important(badge, 'max-width', '17px');
      important(badge, 'height', '17px');
      important(badge, 'min-height', '17px');
      important(badge, 'max-height', '17px');
      important(badge, 'padding', '0');
      important(badge, 'border-radius', '999px');
      important(badge, 'background', '#000');
      important(badge, 'color', '#fff');
      important(badge, 'font-size', '9px');
      important(badge, 'font-weight', '700');
      important(badge, 'line-height', '1');
      important(badge, 'transform', 'none');
      important(badge, 'transition', 'none');
      important(badge, 'animation', 'none');
      important(badge, 'will-change', 'auto');
      important(badge, 'pointer-events', 'none');
      important(badge, 'z-index', '6');
    });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      alignWishlistBadges();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alignWishlistBadges, { once: true });
  else alignWishlistBadges();
  window.addEventListener('load', alignWishlistBadges, { once: true });
  [0, 80, 180, 360, 720, 1400, 2800].forEach((delay) => window.setTimeout(alignWishlistBadges, delay));
  document.addEventListener('zoalin:wishlist-changed', schedule);
  document.addEventListener('zoalin:wishlist:changed', schedule);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style', 'hidden'],
  });
  if (mq && mq.addEventListener) mq.addEventListener('change', alignWishlistBadges);
})();
